import { Action } from '@ngrx/store';
import { IRace } from 'src/app/models/race.interface';

export enum ERaceActions {
    GetRace = '[Race] Get Race',
    GetRaceVideoXBNET = '[Race] Get Video Replay XBENET',
    GetRaceSuccess = '[Race] Get Race Success'
}

export class GetRace implements Action {
    public readonly type = ERaceActions.GetRace;
    constructor(public payload: number) {}
}

export class GetRaceVideoXBNET implements Action {
    public readonly type = ERaceActions.GetRaceVideoXBNET;
    constructor(public payload: IRace) {}
}

export class GetRaceSuccess implements Action {
    public readonly type = ERaceActions.GetRaceSuccess;
    constructor(public payload: IRace) {}
}

export type RaceActions =
 | GetRace
 | GetRaceVideoXBNET
 | GetRaceSuccess;
